<template>
  <div id="wrap">
    <button @click="exportFile">导出PDF</button>
    <div class="test" id="container">
      sdfsdf
    </div>
  </div>
</template>
<script>
import htmlToPdf from './htmlToPdf'
Vue.use(htmlToPdf)
import { api_post } from '../../utils/http'
import Vue from 'vue'
import Vuex from 'vuex'
export default {
  name: 'home',
  props: {
    pdfSource: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      src: '',
      currentPage: 0,
      pageCount: 0,
      numPages: null,
      questionData: [],
      config: {
        container: '#container',
        framework: {
          vue: Vue,
          vuex: Vuex
        },
        questionList: [],
        showRightAnswer: false,
        showUserAnswer: true,
        showAnalysis: true,
        onQuestionRender: function(qobj) {
          console.log('onQuestionRender')
          console.log(qobj)
        }
      }
    }
  },
  components: {},
  methods: {
    insertSource(url, type) {
      return new Promise((resolve) => {
        if (this.judgeResourceExist(url, type)) {
          return resolve(true)
        }
        let source = document.createElement(type)
        //分别处理js,css
        if (type == 'script') {
          source.src = url
          source.id = 'venuspreScript'
        } else {
          source.href = url
          source.type = 'text/css'
          source.rel = 'stylesheet'
        }

        source.onload = function() {
          resolve(true)
        }
        document.body.appendChild(source)
      })
    },
    //判断资源是否重复加载
    judgeResourceExist(attrValue, type) {
      const whiteList = {
        script: `script[src="${attrValue}"]`,
        link: `style[href="${attrValue}"]`
      }

      if (whiteList[type] === undefined) {
        console.error(`类型不正确:${type}`)
        return false
      }

      const ele = document.querySelector(whiteList[type])
      if (ele !== null) {
        return true
      }

      return false
    },
    exportFile() {
      this.getPdf('container', '17试卷')
    },
    async init(ids) {
      console.log(ids)
      const scriptUrl = 'https://cdn-cnc.17zuoye.cn/zion/venus-pre/0.3.10/venus-pre.min.js'
      const cssUrl = 'https://cdn-cnc.17zuoye.cn/zion/venus-pre/0.3.10/css/venus-pre.min.css'
      // let {questions} = await this.getQuestionPreviewInfo(ids)
      // this.$nextTick(function(){
      // this.config.questionList = questions
      this.config.questionList = this.questionData
      await Promise.all([this.insertSource(scriptUrl, 'script'), this.insertSource(cssUrl, 'link')])
      VenusPre.init(this.config)

      // })
    },
    async getQuestionPreviewInfo(ids) {
      ids = ids || []
      const online = ids.filter((id) => id.includes('-')).length > 0 // 题目是否线上版本

      // return api_post('/service/flash/' + (online ? 1 : 0), {data: JSON.stringify({ids})}).then(data => {
      //   return {questions: [data.result[ids[0]].questions[0]]}
      // })
      return api_post('/service/flash/0' + (online ? 1 : 0), {
        data: JSON.stringify({ ids })
      }).then((data) => {
        return { questions: [data.result[ids[0]].questions[0]] }
      })
    }
  },
  mounted() {
    // let ids = ['Q_10209389212031']
    // this.init(ids)
    // this.src.then((pdf) => {
    //   console.log('pdf loaded')
    //   this.pageCount = pdf.numPages
    // })
  }
}
</script>

<style lang="scss">
#wrap {
  font-size: 20px;
}
.wrapper {
  width: 100%;
  > span {
    width: 100%;
  }
}
</style>
